<template v-slot:append>
  <v-dialog v-bind="computedProps" v-on="computedListeners" v-model="showDialog">
    <v-card min-height="75%" min-width="80%">
      <v-toolbar elevation="2" color="primary" dark dense>
        <v-spacer/>
        <v-toolbar-title>
          紐づけ配車表検索
        </v-toolbar-title>
        <v-spacer/>
        <v-btn @click="onCloseClick" text>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>
          <v-row no-gutters>
            <v-col :cols="2" class="px-1">
              <span class="search-number">{{ filteredRows.length }}</span>件 の検索結果
            </v-col>
            <v-col :cols="4" />
            <v-col :cols="3" class="mt-2">
              <span class="text-right-black-bold">さらにフリーワードで絞り込む</span>
            </v-col>
            <v-col :cols="3" class="px-1">
              <dd-narrow-down-text-box label="" adjustStyle="padding-top:0px" v-model="searchText"/>
            </v-col>
          </v-row>

          <hr class="section-line mb-2">

          <v-row no-gutters justify="end">
            <v-col :cols="3" />
            <v-col :cols="9">
              <v-row no-gutters justify="end">
                <dd-select-items-per-page
                  ref="pagination1"
                  :itemsPerPage.sync="itemsPerPage"
                  :currentPage.sync="page"
                  :items="filteredRows"
                  @changeItemsPerPage="changeItemsPerPage"
                  @changePage="changePage"
                />
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col :cols="12">
            <v-data-table
              item-key="torisakiCd"
              :headers="headers"
              :items="filteredRows"
              :search="searchText"
              :items-per-page="itemsPerPage"
              :page.sync="page"
              @dblclick:row="onRowDoubleClick"
              no-data-text="対象データはありません"
              fixed-header
              hide-default-footer
              locale="ja-jp"
              dense
            >
              <template v-slot:[`item.actions`]="{item}">
                <template>
                  <v-chip
                    small
                    color="primary"
                    @click="onRowSelectButtonClick(item)"
                  >
                    選択
                  </v-chip>
                </template>
              </template>
            </v-data-table>
            <!--
              <dd-data-table
                v-model="selectedItem"
                calculate-widths
                :height="tableHeight*0.7"
                item-key="id"
                showSelect
                @click:row="onRowClick"
                @dblclick:row="onRowDoubleClick"
                :headers="headers"
                :items="filteredRows"
                :search="searchText"
                :loading="loading"
                :header-props="{sortByText: '並び替え'}"
                :footer-props="{'items-per-page-options': [100, 200, 300, 400, 500],showFirstLastPage: true,}"
                loading-text="検索中のため、少々お待ちください。"
                :itemsPerPage=100
                fixed-header
                locale="ja-jp"
                no-data-text="利用可能なデータはありません。"
                dense
                :page.sync ="page"
                />
              -->
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-row no-gutters class="px-1 py-0 mt-3" v-if="filteredRows.length > 0">
          <v-col :cols="3">
            <dd-transparent-button :minWidth="120" @click="onCloseClick">
              <v-icon color="#1F2B38">mdi-close-circle</v-icon>閉じる
            </dd-transparent-button>
          </v-col>
          <v-col :cols="9">
            <v-row no-gutters justify="end">
              <dd-select-items-per-page
                ref="pagination2"
                :itemsPerPage.sync="itemsPerPage"
                :currentPage.sync="page"
                :items="filteredRows"
                @changeItemsPerPage="changeItemsPerPage"
                @changePage="changePage"
              />
            </v-row>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import DdTransparentButton from '@/components/DdTransparentButton'

import controls from '@/rahmen/controls'
import flowMixin from '@/mixins/flowMixins'
// import filter from '@/rahmen/utils/filters'

import { mapGetters } from 'vuex'

const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')
const DdSelectItemsPerPage = () => import('@/components/DdSelectItemsPerPage')

export default {
  name: 'DdHimodukeHaishahyoSearchDialog',
  mixins: [flowMixin],
  components: {
    DdTransparentButton,
    DdNarrowDownTextBox,
    DdSelectItemsPerPage
  },
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    /**
     * ダイアログタイトル
     */
    titleText: String,
    /**
     * 親画面選択値
     */
    itemList: Array

  },
  data: () => ({
    conditions: {},
    searchText: '',
    ctypes: controls,
    /**
     * 一覧内容
     */
    headers: [
      { text: '', value: 'actions', sortable: false, width: '20px' },
      { text: 'ID', value: 'id', align: ' d-none' },
      { text: '配車表コード', value: 'haishahyoCd', align: 'center', width: '10vw' },
      { text: '配車表表示名', value: 'haishahyoNm' }
    ],
    rows: [],
    loading: false,
    selectedItem: [],
    // 一覧制御用
    itemsPerPage: 25,
    page: 1

    /*
     *
     */
  }),
  created () {
  },
  mounted () {
    this.initialize()
    // this.fetchData()
  },
  computed: {
    ...mapGetters({
    }),
    filteredRows () {
      return this.rows
    },
    computedProps () {
      return {
        ...this.$props,
        persistent: true,
        noClickAnimation: true,
        maxWidth: '85%'
      }
    },
    computedListeners () {
      return {
        ...this.$listeners,
        persistent: true,
        noClickAnimation: true,
        scrollable: true,
        maxWidth: '80%'
      }
    }
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    /**
     * 全件取得 ※表示時のみ
     * @returns
     */
    fetchData: function (selectedRow) {
      return new Promise((resolve) => {
        this.HttpClient
          .get('api/v1/MstHaishahyo/GetAll')
          .then((data) => {
            console.log(selectedRow)
            var dataList = data.payload
            dataList = dataList.filter((elem) => {
              return elem.hyojiFlg
            })
            dataList.forEach(p => {
              const res = {}
              res.id = p.id
              res.delFlg = false
              res.haishahyoCd = p.haishahyoCd
              res.haishahyoNm = p.haishahyoNm
              var dispFlg = true

              if (selectedRow) {
                var duplicateRow = selectedRow.filter((elem) => {
                  return elem.haishahyoCd === res.haishahyoCd
                })
                dispFlg = duplicateRow.length === 0
              }
              if (dispFlg) {
                if (this.rows.length > 0) {
                  this.rows.push(res)
                } else {
                  this.rows = [res]
                }
              }
            })
          })
      })
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: [],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
            }
            this.selectedItem = []
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          return new Promise(resolve => {
            self.search().then(() => {
              resolve()
            })
          })
        },
        restoreViewPromise: (c) => {
          console.log('MstHaishahyo.restoreViewPromise', c)
          return new Promise(resolve => {
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('MstHaishahyo.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        },
        settingViewScroll: () => {
          return true
        },
        settingLoadEffect: function () {
          return true
        }
      }
      this.initializeForViewer(opt)
    },
    onRowDoubleClick: function (e, f) {
      /**
       * 選択時クローズ処理
       * @event doubleClick
       * @type {Event}
       */
      console.log('row double clicked', e)
      console.log('row double clicked', f)
      this.selectedItem = [f.item]
      if (this.selectedItem.length === 0) {
        this.$emit('close', undefined)
      } else {
        this.$emit('close', this.selectedItem)
      }
      // this.initBindVariables()
      this.searchText = ''
      this.rows = []
      this.selectedItem = []
    },
    onRowSelectButtonClick: function (item) {
      this.selectedItem = [item]
      console.log('onRowSelectButtonClick', item)
      this.$emit('close', this.selectedItem)
    },
    onCloseClick: function (e) {
      /**
       * 無選択クローズ処理
       * @event click
       * @type {Event}
       */
      console.log('close clicked', this.showDialog)
      this.$emit('close', undefined)
      console.log('emited', this.showDialog)
      this.searchText = ''
      this.rows = []
      this.selectedItem = []
      // this.clear(false)
    },
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      const self = this
      self.itemsPerPage = e
      // 子コンポーネントへの反映
      self.$nextTick().then(() => {
        if (self.$refs.pagination1) {
          self.$refs.pagination1.syncPagination(self.itemsPerPage, self.page)
        }
        if (self.$refs.pagination2) {
          self.$refs.pagination2.syncPagination(self.itemsPerPage, self.page)
        }
      })
    },
    changePage: function (e) {
      const self = this
      self.page = e
      // 子コンポーネントへの反映
      self.$nextTick().then(() => {
        if (self.$refs.pagination1) {
          self.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        }
        if (self.$refs.pagination2) {
          self.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
        }
      })
    }
  }
}
</script>
<style scoped>
div.v-dialog__content.v-dialog__content--active {
   z-index: 400 !important;
}
</style>
